.report-icon-container {
    display: flex;
    width: 32px;
    height: 32px;
    justify-content: center;
    align-items: center;
    margin-right: 16px;
    border-radius: 8px;
    background: var(--info-bg);
}

.card-content {
    display: flex;
    max-width: 325px;
    width: 100%;
    padding: 12px;
    min-width: 0;
    box-sizing: border-box;
}

.report-card-wrapper {
    cursor: pointer;
    border-radius: 8px;
    border: 1px solid transparent;
}

.report-card-wrapper:hover {
    border: 1px solid var(--grey-lt);
}
